import { useRequestWithdrawal } from "@/client/services/withdrawals/create-request";
import { useDialog } from "@/client/stores/dialog";
import { t } from "@lingui/macro";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Form,
  FormField,
  FormLabel,
  Input,
  FormItem,
  FormControl,
} from "@reactive-resume/ui";
import { WithdrawalWithUser } from "libs/dto/src/withdrawal";
import { useRef } from "react";
import { useForm } from "react-hook-form";

export const RequestWithdrawalDialog = () => {
  type FormValue = { amount: number };
  const formRef = useRef<HTMLFormElement>(null);
  const { RequestWithdrawal } = useRequestWithdrawal();
  const { isOpen, mode, close } = useDialog<WithdrawalWithUser>("request-with");
  const form = useForm<FormValue>({
    defaultValues: { amount: 0 },
  });
  const OnSubmit = (data: any) => {
    try {
      const payload = { amount: Number(data.amount) };
      RequestWithdrawal(payload);
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Demander un retrait`}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <FormField
              name="amount"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Montant du retrait`}</FormLabel>
                  <FormControl>
                    <Input type="number" {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            <div className="flex flex-row justify-center">
              <Button type="submit" className="bg-moncvpro-secondary">
                {t`Valider`}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
